<template>
  <a-table
    :columns="columns"
    :dataSource="data"
    rowKey="id"
    :pagination="pagination"
    @change="handleTableChange"
  >
    <template slot="action" slot-scope="text, record">
      <a @click="handleApprove(record)">通过</a>
      <a-divider type="vertical" />
      <a @click="handleReject(record)">拒绝</a>
      <a-divider type="vertical" />
      <a @click="handleView(record)">查看</a>
    </template>
  </a-table>
</template>

<script>
const columns = [
  {
    title: '申请时间',
    dataIndex: 'applyTime',
    sorter: true
  },
  {
    title: '申请人',
    dataIndex: 'teacher'
  },
  {
    title: '课程名称',
    dataIndex: 'courseName'
  },
  {
    title: '原时间/教室',
    dataIndex: 'originalInfo'
  },
  {
    title: '调整后时间/教室',
    dataIndex: 'adjustedInfo'
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 10,
        total: 0
      })
    }
  },
  data() {
    return {
      columns
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.$emit('change', pagination, filters, sorter)
    },
    handleApprove(record) {
      this.$emit('approve', record)
    },
    handleReject(record) {
      this.$emit('reject', record)
    },
    handleView(record) {
      this.$emit('view', record)
    }
  }
}
</script>